import {Injectable} from "@angular/core";
import {TableOptionsService} from "@app/_services/table-options.service";
import {VineMedsS3ObjectVersion} from "@app/_models/api";
import {GlobalService} from "@app/_services/global.service";
import {environment} from "@environments/environment";
import {ApiService} from "@app/_services/api.service";

@Injectable({
    providedIn: 'root'
})
export abstract class ExtractsService extends TableOptionsService<VineMedsS3ObjectVersion> {

    protected constructor(public apiService: ApiService, globalService: GlobalService) {
        super();
        this.pageSize = globalService.pagination[0];
        this.sortDirection = 'desc';
        this.sortColumn = 'loadTime';
    }

    public override matches(element: VineMedsS3ObjectVersion, term: string) {
        return (
            element.key?.toLowerCase().includes(term.toLowerCase()) ||
            element.fileName?.toLowerCase().includes(term.toLowerCase())
        );
    }

    downloadRawFile(customerId: string, key: string, versionId: string): void {
        const endpoint = `${environment.apiUrl}/admin/customers/${customerId}/extract/version/${versionId}?key=${encodeURIComponent(key)}`;
        this.apiService.handleDownloadFile(endpoint);
    }
}
